import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa'; // Close icon
import ArchiveConfirm from './ArchiveConfirm'; // Import ArchiveConfirm component
import ChangeInfoConfirm from './ChangeInfoConfirm'; // Import ChangeInfoConfirm component
import ChangeImageConfirm from './ChangeImageConfirm'; // Import ChangeImageConfirm component

const ManageModal = ({ orgName, onClose }) => {
    const [isExpanded, setIsExpanded] = useState(false); // Track modal expansion

    const modalStyle = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1000,
        backgroundColor: '#fff',
        padding: '30px',
        borderRadius: '8px',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
        width: isExpanded ? '600px' : '400px', // Expands when Change Info or Change Image is clicked
        textAlign: 'center', // Center the content in the modal
        transition: 'width 0.3s ease', // Smooth transition when expanding
    };

    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 999, // Ensure the overlay is behind the modal
    };

    const closeButtonStyle = {
        position: 'absolute',
        top: '-15px',
        right: '-15px',
        backgroundColor: '#dc3545',
        color: 'white',
        fontSize: '14px',
        border: 'none',
        borderRadius: '50px',
        padding: '10px 15px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
    };

    const headerStyle = {
        fontSize: '18px',
        marginBottom: '20px',
        fontWeight: 'bold',
        textAlign: 'left', // Align the header to the left
    };

    const darkButtonStyle = {
        display: 'block',
        width: '100%',
        padding: '10px',
        margin: '10px 0',
        backgroundColor: '#343a40',
        color: 'white',
        borderRadius: '4px',
        fontSize: '14px',
        fontWeight: 'bold',
        cursor: 'pointer',
        border: 'none',
    };

    return (
        <>
            <div style={overlayStyle} onClick={onClose} />
            <div style={modalStyle}>
                <button style={closeButtonStyle} onClick={onClose}>
                    <FaTimes style={{ marginRight: '5px' }} /> Close
                </button>
                <h2 style={headerStyle}>{orgName} Manager</h2>
                
                {/* Archive button and confirmation */}
                <ArchiveConfirm orgName={orgName} />

                {/* Change Info button and confirmation */}
                <ChangeInfoConfirm orgName={orgName} onExpand={setIsExpanded} />

                {/* Change Images button and confirmation */}
                <ChangeImageConfirm orgName={orgName} onExpand={setIsExpanded} />
            </div>
        </>
    );
};

export default ManageModal;
